import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import JitsiMeeting from "@/components/lingo/JitsiMeeting";
import { ExternalLink } from "lucide-react";

export default function ClassroomRoom() {
  const { id } = useParams();
  const { user } = useAuth();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/classrooms/${id}`).then((r) => setC(r.data)); }, [id]);

  if (!c) return <DashboardLayout title="Loading..."><div className="text-slate-400">Loading classroom...</div></DashboardLayout>;
  return (
    <DashboardLayout title={c.title}>
      <div className="grid lg:grid-cols-12 gap-5">
        <div className="lg:col-span-9">
          <JitsiMeeting roomName={c.room_name} displayName={user?.name} />
          <div className="mt-3 text-xs text-slate-400 flex items-center gap-4">
            <span>Room: <span className="font-mono">{c.room_name}</span></span>
            {c.google_meet_link && (
              <a href={c.google_meet_link} target="_blank" rel="noreferrer" data-testid="open-meet-link" className="hover:text-slate-900 inline-flex items-center gap-1">
                <ExternalLink className="w-3 h-3" /> Open in Google Meet
              </a>
            )}
          </div>
        </div>
        <aside className="lg:col-span-3 bg-white border border-slate-200 rounded-2xl p-5">
          <div className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-3">Class info</div>
          <div className="text-sm">{c.description || "No description provided."}</div>
          <div className="mt-6 text-xs font-mono uppercase tracking-widest text-slate-400 mb-3">Scheduled</div>
          <div className="text-sm">{c.scheduled_at?.replace("T", " ") || "Open now"}</div>
          <div className="mt-6 text-xs font-mono uppercase tracking-widest text-slate-400 mb-3">Host</div>
          <div className="text-sm">{c.host_name || "—"}</div>
        </aside>
      </div>
    </DashboardLayout>
  );
}
